/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventFloorInfo,
    JsonEventFloorInfoFromJSON,
    JsonEventFloorInfoFromJSONTyped,
    JsonEventFloorInfoToJSON,
} from './JsonEventFloorInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventFloorInfo
 */
export interface ApiResultOfJsonEventFloorInfo {
    /**
     * 
     * @type {JsonEventFloorInfo}
     * @memberof ApiResultOfJsonEventFloorInfo
     */
    data?: JsonEventFloorInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventFloorInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventFloorInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventFloorInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventFloorInfo
     */
    result?: ApiResultOfJsonEventFloorInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventFloorInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventFloorInfoFromJSON(json: any): ApiResultOfJsonEventFloorInfo {
    return ApiResultOfJsonEventFloorInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventFloorInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventFloorInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventFloorInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventFloorInfoToJSON(value?: ApiResultOfJsonEventFloorInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventFloorInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

